export const cabinClassData = [
    {value: 'Economy', label: 'Economy'},
    {value: 'PremiumEconomy', label: 'Premium Economy'},
    {value: 'Business', label: 'Business'},
    {value: 'FirstClass', label: 'First Class'},
]